import { IDichVuHoSoActionTypes } from "../../action-types/dich-vu/IDichVuHoSoActions";
import { IDichVuHoSoReducer } from "../../reducer-model/dich-vu/IDichVuHoSoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDichVuHoSoReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dichVuHoSos: [],
  idSelections: [],
};
export const dichVuHoSoReducer = (
  state: IDichVuHoSoReducer = iniState,
  action: IDichVuHoSoActionTypes,
): IDichVuHoSoReducer => {
  switch (action.type) {
    case "DICH_VU_HO_SO_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "DICH_VU_HO_SO_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dichVuHoSos: action.payload,
      };
    case "DICH_VU_HO_SO_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_HO_SO_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DICH_VU_HO_SO_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "DICH_VU_HO_SO_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_HO_SO_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DICH_VU_HO_SO_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DICH_VU_HO_SO_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DICH_VU_HO_SO_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        dichVuHoSoEditing: action.payload,
      };
    case "DICH_VU_HO_SO_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        dichVuHoSoEditing: undefined,
      };
    case "DICH_VU_HO_SO_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "DICH_VU_HO_SO_SHOW_HIDE_IMPORT_MODAL":
      return {
        ...state,
        isShowImportModal: action.payload,
      };
    case "DICH_VU_HO_SO_IMPORT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "DICH_VU_HO_SO_IMPORT_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_saved,
      };
    case "DICH_VU_HO_SO_IMPORT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowImportModal: false,
      };
    case "DICH_VU_HO_SO_DELETE_MANY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "DICH_VU_HO_SO_DELETE_MANY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_deleted,
      };
    case "DICH_VU_HO_SO_DELETE_MANY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };

    default:
      return state;
  }
};
